var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96936 2.46936C7.03903 2.39952 7.1218 2.34411 7.21291 2.3063C7.30403 2.26849 7.40171 2.24902 7.50036 2.24902C7.59901 2.24902 7.6967 2.26849 7.78781 2.3063C7.87893 2.34411 7.9617 2.39952 8.03136 2.46936L17.0314 11.4694C17.1012 11.539 17.1566 11.6218 17.1944 11.7129C17.2322 11.804 17.2517 11.9017 17.2517 12.0004C17.2517 12.099 17.2322 12.1967 17.1944 12.2878C17.1566 12.3789 17.1012 12.4617 17.0314 12.5314L8.03136 21.5314C7.89053 21.6722 7.69953 21.7513 7.50036 21.7513C7.3012 21.7513 7.11019 21.6722 6.96936 21.5314C6.82853 21.3905 6.74942 21.1995 6.74942 21.0004C6.74942 20.8012 6.82853 20.6102 6.96936 20.4694L15.4399 12.0004L6.96936 3.53136C6.89952 3.4617 6.8441 3.37893 6.80629 3.28781C6.76849 3.1967 6.74902 3.09902 6.74902 3.00036C6.74902 2.90171 6.76849 2.80403 6.80629 2.71291C6.8441 2.6218 6.89952 2.53903 6.96936 2.46936Z",
    fill: "#1C2026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.25959b0a128698a80e9e7fe30bacb799.svg";
export { ForwardRef as ReactComponent };